import React from 'react';
import { FiCalendar } from 'react-icons/fi';
import { format } from 'date-fns';

/**
 * DateRangeDisplay Component
 * Shows the currently selected date range explicitly on the page
 * Required for audit clarity and user awareness
 *
 * Usage: <DateRangeDisplay startDate={startDate} endDate={endDate} />
 */
const DateRangeDisplay = ({ startDate, endDate, label, toneEnabled }) => {
  const formatDate = (date) => {
    if (!date) return '---';
    try {
      const d = typeof date === 'string' ? new Date(date) : date;
      return format(d, 'dd MMM yyyy');
    } catch {
      return '---';
    }
  };

  return (
    <div style={{
      display: 'flex',
      alignItems: 'center',
      flexWrap: 'wrap',
      gap: '4px 8px',
      padding: '6px 10px',
      background: '#f8f9fa',
      borderRadius: 6,
      border: '1px solid #e9ecef',
      fontSize: '0.82rem',
      color: '#495057',
      maxWidth: '100%',
    }}>
      <FiCalendar size={14} style={{ color: '#6c757d' }} />
      <span style={{ fontWeight: 500 }}>
        {label || (toneEnabled ? 'Data:' : 'Data From')}
      </span>
      <span style={{ color: '#2c3e50', fontWeight: 600 }}>
        {formatDate(startDate)}
      </span>
      <span style={{ color: '#7F8C8D' }}>
        {toneEnabled ? 'se' : 'to'}
      </span>
      <span style={{ color: '#2c3e50', fontWeight: 600 }}>
        {formatDate(endDate)}
      </span>
    </div>
  );
};

export default DateRangeDisplay;
